import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { validateEmail } from 'globals/validation';
import InputWithSubmit from 'shared/components/InputWithSubmit';
import styles from './styles';
import * as selectors from '../ChatConversationDescribe/selectors';
import * as actions from '../ChatConversationDescribe/actions';
import messages from './messages';

class ChatConversationDescribeEmail extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      error: '',
    };
  }

  handleEmailChange = event => {
    this.setState({ error: '', email: event.target.value });
  };

  handleSubmit = value => {
    const { submit, intl } = this.props;

    if (!validateEmail(value)) {
      this.setState({ email: '', error: intl.formatMessage(messages.failure_message) });
      return;
    }

    this.setState({ error: '' });
    submit(value);
  };

  renderSuccess() {
    const { emailAddress } = this.props;
    return (
      <div style={styles.successWrapper}>
        <div style={styles.success}>
          <FormattedMessage {...messages.success_message} />
          <br />
          {emailAddress}
        </div>
      </div>
    );
  }

  renderInput() {
    const { intl } = this.props;
    const { email, error } = this.state;

    return (
      <div style={styles.inputWrapper} className="kustomer-app-email-banner">
        <div className="describeEmailTitle kustomer-app-email-banner-label" style={styles.title}>
          <FormattedMessage {...messages.title} />
        </div>
        <InputWithSubmit
          style={styles.input}
          placeholder={intl.formatMessage(messages.placeholder)}
          onChange={this.handleEmailChange}
          onSubmit={this.handleSubmit}
          value={email}
          error={error}
        />
      </div>
    );
  }

  renderInputOrSuccess() {
    const { success } = this.props;
    if (success) return this.renderSuccess();

    return this.renderInput();
  }

  render() {
    return this.renderInputOrSuccess();
  }
}

ChatConversationDescribeEmail.propTypes = {
  submit: PropTypes.func,
  emailAddress: PropTypes.string,
  success: PropTypes.bool,
  intl: intlShape.isRequired,
};

ChatConversationDescribeEmail.defaultProps = {
  success: false,
  emailAddress: '',
  submit: () => {},
};

export const intlChatConversationDescribeEmail = injectIntl(ChatConversationDescribeEmail, { withRef: true });

const mapStateToProps = state => ({
  success: selectors.getEmailSuccess(state),
  emailAddress: selectors.getEmailAddress(state),
});

const mapDispatchToProps = dispatch => ({
  submit: email => dispatch(actions.handleDescribeUserEmail(email)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(intlChatConversationDescribeEmail);
